import { createActionCreator } from 'deox'

export const setBalance = createActionCreator(
  'SET_BALANCE',
  (resolve) => (amount: string) => resolve(amount),
)

export const setBalanceLPT = createActionCreator(
  'SET_BALANCE_LPT',
  (resolve) => (amount: string) => resolve(amount),
)

export const setAccount = createActionCreator(
  'SET_ACCOUNT',
  (resolve) => (account: string) => resolve(account),
)

export const setNewClaimChain = createActionCreator(
  'SET_NEW_CLAIM_CHAIN',
  (resolve) => (chainId: number) => resolve(chainId),
)

export const setDesiredNetworkId = createActionCreator(
  'SET_DESIRED_NETWORK_ID',
  (resolve) => (chainId: number) => resolve(chainId),
)

export const setBalanceEth = createActionCreator(
  'SET_BALANCE_ETH',
  (resolve) => (balance: string) => resolve(balance),
)

export const setIsEthRaise = createActionCreator(
  'SET_IS_ETH_RAISE',
  (resolve) => (isEthRaise: boolean) => resolve(isEthRaise),
)

export const setBalanceTokenSale = createActionCreator(
  'SET_BALANCE_TOKEN_SALE',
  (resolve) => (balance: string) => resolve(balance),
)

export const setActiveTokenSaleAddress = createActionCreator(
  'SET_ACTIVE_TOKEN_SALE_ADDRESS',
  (resolve) => (address: string) => resolve(address),
)

export const setEthUsdPrice = createActionCreator(
  'SET_ETH_USD_PRICE',
  (resolve) => (price: number) => resolve(price),
)
